<template>
    <div ref="battery80"></div>
</template>

<script>
import Battery80 from "!!raw-loader!../../assets/ricoh_assets/icons/ICN001-04_battery_80.svg" // loads SVG Icons as String via Webpack.
export default {
    mounted() {
        let shadowRoot = this.$refs.battery80.attachShadow({mode: 'open'})
        shadowRoot.innerHTML = Battery80

        const style = document.createElement('style')
        style.innerHTML = `svg { width: 100%; height: 100%; }`

        const clonedStyle = style.cloneNode(true)
        shadowRoot.appendChild(clonedStyle)
    }
}
</script>

<style>
</style>